import styled from 'styled-components';

export const ContributorWrapper = styled.div`
  display: flex;
  flex-direction: ${({ theme }) => (theme.mode === 'row' ? 'row' : 'column')};
  ${({ theme }) =>
    theme.mode === 'row'
      ? `
        align-items: center;
      `
      : ``}
  gap: 16px;

  & > :first-child {
    cursor: pointer !important;
  }

  cursor: pointer;
`;

export const ContributorInformationContainer = styled.div`
  display: flex;
  flex-direction: column;

  ${({ theme }) =>
    theme.mode === 'row'
      ? `
        align-items: flex-start;
      `
      : ``}
`;

export const ContributorCompany = styled.span`
  font-weight: 500;
  text-align: center;
  font-size: 14px;
  line-height: normal;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  color: rgba(23, 28, 51, 0.5);
`;

export const ContributorName = styled.h6`
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  color: var(--color-text);
`;

export const ContributorRole = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: normal;
  text-align: center;
  color: rgba(23, 28, 51, 0.5);
`;

export const ContributorDate = styled.span`
  font-weight: 500;
  font-size: 14px;
  line-height: normal;
  letter-spacing: 1.4px;
  text-transform: uppercase;

  color: rgba(23, 28, 51, 0.5);
`;

export const ContributorCompanyLogoContainer = styled.div`
  position: absolute;
  top: 0px;
  right: 0px;

  transform: translate(25%, -25%);
`;
